/**
 * The code in this file was derived from, or influenced by, TerriaJS:
 * https://github.com/TerriaJS/terriajs
 */

import { Option } from 'app/shared/components/ims_object_selector/ims_item_selector';
import parser from 'fast-xml-parser';

export default abstract class MapService {
    public _url: string;
    public _name: string;
    public _layers: any[];
    public _layerLimit: number;
    public _fetch: (url: string) => Promise<Response>;
    public optionalParameters: { [key: string]: any };
    public _hasDataError: boolean;

    constructor(url: string, fetch = async (url) => await window.fetch(url)) {
        this._url = url;
        this._name = url;
        this._layers = [];
        this._layerLimit = 1;
        this._fetch = fetch;
        this.optionalParameters = {};
        this._hasDataError = false;
    }

    get url() {
        return this._url;
    }

    get name() {
        return this._name;
    }

    get layers() {
        return MapService.buildLayers(this._layers);
    }

    get layerLimit() {
        return this._layerLimit;
    }

    get hasDataError() {
        return this._hasDataError;
    }

    abstract load(): Promise<void>;

    abstract hasOptionalParameter(key: string): boolean;

    abstract getOptionalParameter(key: string): string[];

    cleanAndProxyUrl(url) {
        const urlObj = new URL(url);
        const query = new URLSearchParams(urlObj.searchParams);

        urlObj.search = '';

        return {
            baseUrl: urlObj.toString(),
            query,
        };
    }

    buildDropdownOptions(items: string[]): Array<Option> {
        return items.map((item) => ({
            label: item,
            value: item,
        }));
    }

    convertXmlToJson(xml: string) {
        const options = {
            arrayMode: false,
        };
        return parser.convertToJson(parser.getTraversalObj(xml, options), options);
    }

    static buildLayers(items, parentItem?) {
        const layers = [];

        items.forEach((item: any) => {
            if (item.hasOwnProperty('layer')) {
                layers.push({
                    label: item.name,
                    value: item.layer,
                    displayGroup: parentItem ? parentItem.name : null,
                });
            } else {
                layers.push(...MapService.buildLayers(item.layers, item));
            }
        });

        return layers;
    }
}
